import React, { useState, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { InputTextarea } from "primereact/inputtextarea";
// import { Label } from "../../../../components/Inputs";
import { getContentTypeIdFromType, CONTENT_TEXT } from "../Utils";

const TextContentForm = React.forwardRef(({ className, model }, ref) => {
  const [body, setBody] = useState(model.body || "");

  useImperativeHandle(ref, () => ({
    getModel: (noValidate) => {
      const { id } = model;
      return { id, content_type_id: getContentTypeIdFromType(CONTENT_TEXT), body };
    }
  }), [body, model]);

  console.log("TextContent.render()", { className, model });
  return (
    <div className={`${className} pad-`} style={{margin: "-1px"}}>
      <div className="form-group-item-">
        <InputTextarea
          className="w3-block w3-border no-corner"
          value={body}
          rows={5}
          autoResize
          onChange={(event) => setBody(event.target.value)}
        />
      </div>
    </div>
  );
});

TextContentForm.displayName = "TextContentForm";

TextContentForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.object,
};

TextContentForm.defaultProps = {
  className: "",
  model: { body: "" },
};

export default TextContentForm;
